import React from 'react';
import { BP_PRIMARY_BUTTON_CLASSES } from './brandPresenceClasses';

interface IUntypedPurposeNoticeProps {
  purposeName: string;
  /** Sends the operator to the tag's edit form. Absent when the tag cannot be addressed by id. */
  onSetType?: () => void;
}

/**
 * What the AI-visibility page shows in place of the KPIs for a purpose whose tag has no type.
 *
 * A tag written before purpose types existed has never said which of its KPIs measure something and
 * which the question fixed in advance, so rendering everything would present fixed values as
 * results. The tab stays blocked until an operator types the tag; this tells them so and takes them
 * there.
 */
export function UntypedPurposeNotice({ purposeName, onSetType }: IUntypedPurposeNoticeProps) {
  return (
    <div className="bg-white border border-amber-200 rounded-lg shadow-sm p-10 text-center">
      <h3 className="text-base font-bold text-slate-700 mb-1">Set a purpose type for “{purposeName}” to see its KPIs</h3>
      <p className="mx-auto mb-4 max-w-2xl text-sm text-slate-500">
        This purpose was created before purpose types existed, so nothing says which of its KPIs are measurements and which the question
        itself fixes. Choose Discovery, Comparison, Brand probe, Competitor probe or Custom on the tag; this tab shows the KPIs that type
        allows as soon as it is saved.
      </p>
      {onSetType ? (
        <button type="button" onClick={onSetType} className={BP_PRIMARY_BUTTON_CLASSES}>
          Set the purpose type
        </button>
      ) : (
        <p className="text-sm text-slate-500">Open the tag under Settings → Taxonomies → Prompt purpose to set its type.</p>
      )}
    </div>
  );
}
